import { render, staticRenderFns } from "./extras.vue?vue&type=template&id=3d08e564&scoped=true&"
import script from "./extras.vue?vue&type=script&lang=js&"
export * from "./extras.vue?vue&type=script&lang=js&"
import style0 from "./extras.vue?vue&type=style&index=0&id=3d08e564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08e564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d08e564')) {
      api.createRecord('3d08e564', component.options)
    } else {
      api.reload('3d08e564', component.options)
    }
    module.hot.accept("./extras.vue?vue&type=template&id=3d08e564&scoped=true&", function () {
      api.rerender('3d08e564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/pages/extras.vue"
export default component.exports